export const cleanObject = <T extends Record<string, any>>(obj: T) => {
  const cleanedObj: Partial<T> = { ...obj }
  Object.keys(cleanedObj).forEach((key) => {
    if (cleanedObj[key] == null || cleanedObj[key] === '') {
      delete cleanedObj[key]
    }
  })
  return cleanedObj
}
